// extracted by mini-css-extract-plugin
module.exports = {"bannerBackground":"Banner_bannerBackground__2aw0m"};